import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../styles';

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    padding: 12,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  header_actions: {
    color: Colors.APP_COLOR_HIGHLIGHT(),
    background: 'white',
    border: '1px solid white',
    marginLeft: '.5rem',
    '&:hover': {
      background: 'white',
    },
  },
  // titleLayout: {
  //   padding: '1.5rem 1rem',
  //   backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
  //   color: 'white',
  //   borderRadius: '0 !important',
  // },
  // cardLayout: {
  //   marginBottom: '1.2rem',
  //   width: '95%',
  //   margin: 'auto',
  //   fontWeight: 300,
  // },
  titleLayout: {
    padding: 20,
    backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
    color: 'white',
  },
  cardLayout: {
    marginBottom: 6,
    marginLeft: 12,
  },
  tableList: {
    marginTop: 12,
    marginBottom: 6,
  },

  tableHeader: {
    background: 'white',
    border: '1px solid rgb(224 224 224)',
    // borderRadius: '.4rem',
    borderBottom: 'none',
    padding: '1rem .5rem',
    color: '#515151',
  },
  dashboardButton: {
    //float: 'right',
    marginTop: 6,
    marginBottom: 6,
    marginRight: 12,
    //width: '99%',
  },
}));

export default useStyles;
